import { Container } from '@hover/blueprint';
import React from 'react';
import Mobile from './Mobile';
import Desktop from './Desktop';
import Tablet from './Tablet';

const FitIntoYourBusiness: React.FC = () => (
  <Container maxW="8xl" w="100%">
    <Mobile />
    <Tablet />
    <Desktop />
  </Container>
);

export default FitIntoYourBusiness;
